import Overview from "../../shared/payment/overview"

import withOrderSummary from "./with-order-summary"

export default withOrderSummary(Overview)
